import React from 'react';
import './index.css';
import siteConfig from '../../configuration/siteConfiguration';

const FeaturePlanet = ({ competencyPills }) => {
    return (
        <div className='fpc-container'>
            <div className='fpc-core-ring-holder'>
                <div className="fpc-core-ring-4">
                    {competencyPills.map((pill, index) => {
                        if (pill.type == 'card') {  // Only render cards
                            return (
                                <div key={`comp-pill-cntr-${index}`} style={{ position: 'absolute' }}>
                                    <div key={`comp-pill-${index}`} className="fpc-core-card-on-4" style={{ ...pill.style }}>
                                        <div className='fpc-core-card-on-4-bar'></div>
                                        {pill.text}
                                    </div>
                                </div>
                            )
                        }
                        if (pill.type == 'icon') {
                            return (
                                <div style={{ position: 'absolute' }}>
                                    <div key={`comp-pill-${index}`} className="fpc-core-icon-on-4" style={{ ...pill.style }}>
                                        <img src={pill.icon} />
                                    </div>
                                </div>
                            )
                        }
                        if (pill.type == 'dot-icon') {
                            return (
                                <div style={{ position: 'absolute' }}>
                                    <div key={`comp-pill-${index}`} className="fpc-core-dot-icon-on-4" style={{ ...pill.style }}>
                                        <img src={pill.icon} />
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className="fpc-core-ring-3"></div>
                <div className="fpc-core-ring-2">
                    <div style={{ position: 'absolute' }}>
                        <img src={`${siteConfig.assetBaseUrl}/logos/core-capibilities.png`} className='fpc-core-capabilities-logo' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturePlanet;